module.exports = __webpack_public_path__ + "static/img/home.dbc5535.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.png
// module id = P7rK
// module chunks = 1